import styled from "styled-components";
import { btnReset, v } from "../../styles/variables";

export const TTopbar = styled.div`
    width: 100%;
    height: 40px;
    padding: ${v.mdSpacing};
    background-color: ${({ theme }) => theme.bg};
    position: relative;
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.bg};
    jsutify-content: flex-end;
`;

export const TLoginDetails = styled.div`
    color: ${({ theme }) => theme.text};
    font-size: 10pt;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: auto;
`;

export const Ttitle = styled.div`
    color: ${({ theme }) => theme.text};
    font-size: 12pt;
`;

export const UserStatusContainer = styled.div`
    background-color: rgb(3 8 24);
    border-radius: 2rem;
    height: 1.5rem;
    width: 8rem;
    margin-right: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    display: flex;
`;

export const UserStatusIcon = styled.div`
    background-color: rgb(174, 199, 65);
    height: 10px;
    width: 10px;
    border-radius: 50%;
    margin-right: 0.5rem;
`;

export const UserStatusText = styled.div`
    color: ${({ theme }) => theme.text};
    font-size: 9pt;
    letter-spacing: initial;
`;

export const NotesIconWrap = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  padding: 0;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: inherit;

  &:focus-visible {
    outline: 2px solid #2563eb; /* blue-600 */
    outline-offset: 2px;
    border-radius: 6px;
  }
`;

const BaseBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  font-size: 10px;
  line-height: 1;
  padding: 2px 6px;
  border-radius: 999px;
  min-width: 16px;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
`;

export const NotesBadge = styled(BaseBadge)`
  background: #e11d48; /* rose-600 */
  color: #fff;
`;

export const NotesBadgeLoading = styled(BaseBadge)`
  background: transparent;
  color: inherit;
  padding: 2px 4px;
  animation: pulse 1s ease-in-out infinite;

  @keyframes pulse {
    0% { opacity: 0.25; }
    50% { opacity: 1; }
    100% { opacity: 0.25; }
  }
`;

export const NotesBadgeError = styled(BaseBadge)`
  background: #f59e0b; /* amber-500 */
  color: #111827;      /* gray-900 */
`;

/**
 * Marks the What's New button when there are notes the user has not read. A
 * plain dot rather than a count - "there is something new" is the whole
 * message, and a number would only invite counting.
 */
export const WhatsNewDot = styled.span`
  position: absolute;
  top: -3px;
  right: -3px;
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: #e11d48; /* rose-600 */
  border: 1px solid rgba(0, 0, 0, 0.1);
`;

export const UserMenuButton = styled.button`
    ${btnReset};
    color: ${({ theme }) => theme.text};
    font-size: 10pt;
    font-family: inherit;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;

    &:hover {
        background-color: rgba(255, 255, 255, 0.08);
    }

    &:focus-visible {
        outline: 2px solid #2563eb;
        outline-offset: 2px;
    }
`;

/* ---------------------------------------------------------------
   Breadcrumbs. They share the topbar row with the user block, which
   is pushed right by its own margin-left:auto, so this simply sits
   first and takes the space on the left.
   --------------------------------------------------------------- */
export const BreadcrumbNav = styled.nav`
    display: flex;
    align-items: center;
    min-width: 0;
    margin-right: 1rem;
`;

export const BreadcrumbList = styled.ol`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 0.35rem;
    list-style: none;
    margin: 0;
    padding: 0;
    min-width: 0;
`;

export const BreadcrumbItem = styled.li`
    display: flex;
    align-items: center;
    gap: 0.35rem;
    min-width: 0;
`;

export const BreadcrumbLink = styled.button`
    ${btnReset};
    color: ${({ theme }) => theme.text};
    cursor: pointer;
    font-size: 10pt;
    letter-spacing: initial;
    /* A long name truncates rather than pushing the user block off the row. */
    max-width: 16rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    opacity: 0.75;

    &:hover,
    &:focus-visible {
        opacity: 1;
        text-decoration: underline;
    }

    /* The page being looked at reads as the solid one, but stays a link -
       clicking it reloads the section, which is what a user expects when the
       trail is fully clickable. */
    &[aria-current='page'] {
        opacity: 1;
        font-weight: 600;
    }
`;

export const BreadcrumbHome = styled(BreadcrumbLink)`
    display: flex;
    align-items: center;
    font-size: 11pt;
`;

export const BreadcrumbSeparator = styled.span`
    color: ${({ theme }) => theme.text};
    opacity: 0.4;
    font-size: 9pt;
    /* Decorative: the list markup already carries the structure. */
    user-select: none;
`;
